import BaseModelFactory from './base.factory'
import StripeCustomerService from './../services/StripeCustomer.service'
import StripeCustomer from './../models/stripe-customer.model'

class StripeCustomerFactory extends BaseModelFactory {
  static search = async ({ search, pagination, order_by, method }) =>
    await this._search(
      { search, pagination, order_by, method },
      { Service: StripeCustomerService, Model: StripeCustomer }
    )
  static findById = async id =>
    await this._findById(id, {
      Service: StripeCustomerService,
      Model: StripeCustomer,
      expand: ['customer', 'paymentMethod'],
    })
  static findByUserId = async id => {
    return await this._findBy({ user_id: id }, { Service: StripeCustomerService, Model: StripeCustomer })
  }
  static create = payload =>
    this._create(payload, {
      Service: StripeCustomerService,
      Model: StripeCustomer,
    })
}

export default StripeCustomerFactory
